import { lazy } from "react"
const FootTraffic = lazy(() => import("../../footTraffic"))
const Dashboard = lazy(() => import("../../dashboard"))
const BranchKpi = lazy(() => import("../../branchKpi"))
const Survey = lazy(() => import("../../survey"))
const CallCollect = lazy(() => import("../../callCollect/list"))
const CallCollectPickup = lazy(() => import("../../callCollect/pickup"))
const SearchCallCollect = lazy(() => import("../../callCollect/search"))
const SearchCallCollectSku = lazy(() => import("../../callCollect/searchSku"))
const CreateCallOrder = lazy(() => import("../../callCollect/create"))
const UploadCallOrders = lazy(() => import("../../callCollect/uploadOrders"))
const EditCallOrder = lazy(() => import("../../callCollect/edit"))
const CallCollectVerification = lazy(() => import("../../callCollect/verification"))
const CallCollectPicking = lazy(() => import("../../callCollect/picking"))
const Print = lazy(() => import("../../print"))
const Branch = lazy(() => import("../../branch"))
const CallCollectTransactions = lazy(() => import("../../callCollect/transactions"))
const Tickets = lazy(() => import("../../tickets"))
const Ticket = lazy(() => import("../../tickets/edit"))
const OndemandReport = lazy(() => import("../../report"))
const B2bWalkin = lazy(() => import("../../b2bWalkin/index"))
const B2bSearch = lazy(() => import("../../b2bWalkin/search"))
const B2bCorporate = lazy(() => import("../../b2bCorporate/index"))
const B2bCorporateSearch = lazy(() => import("../../b2bCorporate/search"))

export default [
  {
    component: Dashboard,
    path: "/",
  },
  {
    component: BranchKpi,
    path: "/branchKpi",
  },
  {
    component: SearchCallCollect,
    path: "/search-cc",
  },
  {
    component: SearchCallCollectSku,
    path: "/search-sku",
  },
  {
    component: CallCollect,
    path: "/call-and-collect",
  },
  {
    component: CallCollectPickup,
    path: "/pickup-cc",
  },
  {
    component: Survey,
    path: "/survey-cc",
  },
  {
    component: CreateCallOrder,
    path: "/create-call-order",
  },
  {
    component: CreateCallOrder,
    path: "/cc-form/:fullname/:phone"
  },
  {
    component: UploadCallOrders,
    path: "/upload-call-order",
  },
  {
    component: CallCollectVerification,
    path: "/call-collect-verification"
  },
  {
    component: CallCollectPicking,
    path: "/call-collect-picking"
  },
  {
    component: EditCallOrder,
    path: "/edit-call-order/:id",
  },
  {
    component: EditCallOrder,
    path: "/edit-call-order/:id/:otp",
  },
  {
    component: Branch,
    path: "/my-branch",
  },
  {
    component: B2bWalkin,
    path: "/b2b-walkin"
  },
  {
    component: B2bWalkin,
    path: "/b2b-walkin/:referenceNo/:editMode"
  },
  {
    component: B2bSearch,
    path: "/search-walkin"
  },
  {
    component: B2bCorporate,
    path: "/b2b-corporate"
  },
  {
    component: B2bCorporate,
    path: "/b2b-corporate/:referenceNo/:editMode"
  },
  {
    component: B2bCorporateSearch,
    path: "/search-corporate"
  },
  {
    component: Print,
    isPlain: true,
    path: "/print/:templateName/:id"
  },
  //{
  //   component: Print,
  //   isPlain: true,
  //   path: "/print/:templateName",
  // },
  {
    component: CallCollectTransactions,
    path: "/transactions/cc",
  },
  {
    component: OndemandReport,
    path: "/onDemandReports",
  },
  {
    component: Tickets,
    path: "/tickets",
  },
  {
    component: Ticket,
    path: "/ticket/:ticketId",
  },
  {
    component: FootTraffic,
    path: "/foot-traffic",
  }
]
